import axios from 'axios/dist/axios';


const defaultState = {
    evaluationData: {},
    isLoadingEvaluationData: false
};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    evaluationData: defaultState.evaluationData,
    isLoadingEvaluationData: defaultState.isLoadingEvaluationData,
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getEvaluationData: state => state.evaluationData,
    getIsLoadingEvaluationData: state => state.isLoadingEvaluationData,
};


// ======================================================================
// Actions
// ======================================================================

const actions = {
    loadEvaluationData ({ commit, dispatch }) {
        let promise = new Promise((resolve, reject) => {
            commit("setIsLoadingEvaluationData", true);
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/evaluation');
            axiosRequest.then((response) => {
                // ----- Success. -----
                if (typeof response.data.data.EVALUATION !== "undefined") {
                    commit('setEvaluationData', response.data.data.EVALUATION);
                }

                if (typeof response.data.data.ASSESSMENT_SEALED !== "undefined" && typeof response.data.data.ASSESSMENT_SEALED.sealed !== "undefined") {
                    commit('ScoringStore/setIsAssessmentSealed', response.data.data.ASSESSMENT_SEALED.sealed, {root: true});
                }

                if (typeof response.data.data.START_QUESTIONS !== "undefined") {
                    commit('AssessmentStartStore/setStartQuestionsData', response.data.data.START_QUESTIONS, {root: true});
                }
                if (typeof response.data.data.PATIENT_DATA !== "undefined") {
                    commit('AssessmentStartStore/setPatientProfileData', response.data.data.PATIENT_DATA, {root: true});
                }
                if (typeof response.data.data.SHORT_ANSWERS_PREVIEW !== "undefined") {
                    commit('AssessmentStartStore/setShortAnswersPreview', response.data.data.SHORT_ANSWERS_PREVIEW, {root: true});
                }

                dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                resolve(response);
            });
            axiosRequest.catch((error) => {
                // ----- Failure -----
                console.log(error);
                reject(error);
            });
            axiosRequest.then(() => {
                // ----- Always -----
                commit("setIsLoadingEvaluationData", false);
            });
        });

        return promise;
    },

    evaluateAssessment ({ commit }, shortCutParam) {
        let promise = new Promise((resolve, reject) => {
            const data = {
                shortcutUsed: shortCutParam.shortcutUsed,
                urgentEvaluate: shortCutParam.urgentEvaluate
            };
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/evaluateAssessment', data);
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    resolve(response);
                }
                else {
                    reject(error);
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    }
};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {
    setEvaluationData (state, data) {
        state.evaluationData = data;
    },
    setIsLoadingEvaluationData (state, newValue) {
        state.isLoadingEvaluationData = newValue;
    },


    // ----------------------------------------------------------

    resetStore (state) {
        state.evaluationData = defaultState.evaluationData;
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/EvaluationStore.js